import React, {useState, useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";
import './App.css';
import { useNavigate } from "react-router-dom";

const App = () => {
  const [weather, setWeather] = useState({});
  const [location, setLocation] = useState("");
  const [maya, setmaya] = useState([])
  const [slow, setslow] = useState();

  const API_KEY = "815903ad630aefe2787008916bd8f0a0";

  const changeLocation = (event) => {
    setLocation(event.target.value);
    console.log(location);
  };
  const fetchData = async () => {
    setmaya(new Date())
    console.log(maya)
    await axios
      .get(
        `https://api.openweathermap.org/data/2.5/weather?&appid=${API_KEY}&q=${location}&units=metric`
      )
      .then((res) => {
        console.log(res.data);
        
        setWeather(res.data);

        setLocation("");
        console.log(weather);
        if(weather){
          setslow(weather.weather[0].description);
          console.log(slow)

        }
        
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    // fetchData();
  }, [slow]); // Fetch data when the location changes

  const navigate = useNavigate();

 


  return (
    <>
    
       
       
      
      
    <div className=" bad   m-auto d-flex text-center  align-items-center flex-column">
        <div className="text-center my-2  fore  ">
          <h1 className="">Weather Forecast</h1>
        
          <p className="fw-bolder fs-5 text-white  ">
            Please search for weather location of your choice
          </p>
        </div>

        <div className="mt-3 ">
          <div class="searchBox">
            <input
              class="searchInput"
              type="text"
              name="location"
              onChange={changeLocation}
              value={location}
              placeholder="Enter a Location"
            />
            <button class="searchButton" href="#" onClick={fetchData}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="29"
                height="29"
                viewBox="0 0 29 29"
                fill="none"
              >
                <g clip-path="url(#clip0_2_17)">
                  <g filter="url(#filter0_d_2_17)">
                    <path
                      d="M23.7953 23.9182L19.0585 19.1814M19.0585 19.1814C19.8188 18.4211 20.4219 17.5185 20.8333 16.5251C21.2448 15.5318 21.4566 14.4671 21.4566 13.3919C21.4566 12.3167 21.2448 11.252 20.8333 10.2587C20.4219 9.2653 19.8188 8.36271 19.0585 7.60242C18.2982 6.84214 17.3956 6.23905 16.4022 5.82759C15.4089 5.41612 14.3442 5.20435 13.269 5.20435C12.1938 5.20435 11.1291 5.41612 10.1358 5.82759C9.1424 6.23905 8.23981 6.84214 7.47953 7.60242C5.94407 9.13789 5.08145 11.2204 5.08145 13.3919C5.08145 15.5634 5.94407 17.6459 7.47953 19.1814C9.01499 20.7168 11.0975 21.5794 13.269 21.5794C15.4405 21.5794 17.523 20.7168 19.0585 19.1814Z"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      shape-rendering="crispEdges"
                    ></path>
                  </g>
                </g>
                <defs>
                  <filter
                    id="filter0_d_2_17"
                    x="-0.418549"
                    y="3.70435"
                    width="29.7139"
                    height="29.7139"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood
                      flood-opacity="0"
                      result="BackgroundImageFix"
                    ></feFlood>
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    ></feColorMatrix>
                    <feOffset dy="4"></feOffset>
                    <feGaussianBlur stdDeviation="2"></feGaussianBlur>
                    <feComposite in2="hardAlpha" operator="out"></feComposite>
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    ></feColorMatrix>
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_2_17"
                    ></feBlend>
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_2_17"
                      result="shape"
                    ></feBlend>
                  </filter>
                  <clipPath id="clip0_2_17">
                    <rect
                      width="28.0702"
                      height="28.0702"
                      fill="white"
                      transform="translate(0.403503 0.526367)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>

          {weather.name && (
            <div className="card text-dark text-center col-12 mt-4 p-2 ">
              {/* <h1>{new Date()}</h1> */}
              <h2>Location: {weather.name}</h2>
              {/* <h2>Location: {weather.sys[0]}</h2> */}
              <p
                className={ weather.main.temp > 32 ? "text-danger fw-bold" : "text-dark fw-bold"} 
              >
                Temperature: {weather.main.temp} °C
              </p>
              <p className="fw-bold">Humidity: {weather.main.humidity}%</p>
              <p className="fw-bold fs-6 ">
                Condition: {weather.weather[0].description}
              </p>

              {slow == "light rain" ? (
                <img
                  src={require("../src/images/raining.gif")}
                  className=" w-100 bend "
                  alt=""
                />
              ) : 
                slow == "overcast clouds"  ? (
                <img
                  src={require("../src/images/Cloudy.gif")}
                  className="w-100 bend "
                  alt=""
                />
              ) : slow == "clear sky" ? (
                <img
                  src={require("../src/images/suuny.webp")}
                  className="w-100 bend "
                  alt=""
                />
              ) :
              slow == "scattered clouds" ? (
                <img
                  src={require("../src/images/scattered.jpg")}
                  className="w-100 bend "
                  alt=""
                />
              ) : null
             }
         
              
            </div>
          )}
        </div>
       
      </div>

        
   
    
      
    </>
  );
};

export default App;
